import Image from "next/image";
import Link from "next/link";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
// import IFSform from "./ifs-interview-form";
import styles from "../upsc-interview/upsc-interview.module.css";
//import WebBanner from "../../assets/images/upsc/Scholarship-Web-Banner.webp";
import Head from "next/head";

const ifsInterview2023 = () =>{

    const prelimlist =[
        {list:"Consistently producing toppers since 2004"},
        {list:"Experienced Faculty Team (10+ Years)  "},
        {list:"Regular Guidance From Achievers"},
        {list:"Scheduled interaction with bureaucrats (serving and retired)"},
        {list:"Personalised and scientific mentoring"},

      ]

    return(
        <>
            <Head>
                
                <meta charset="UTF-8" />
                
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="robots" content="noodp,noydir" />
                <meta name="robots" content="index,follow" />
                <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
                <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
                <meta property="article:modified_time" content="2026-09-27T05:43:44+00:00" />
                <title>TNPSC GRI Prelims Answer Exam Key 2026 | Shankar IAS Academy</title>
                <meta name="title" content="TNPSC GRI Prelims Exam Answer Key 2026  | Shankar IAS Academy" />
                <meta name="description" content="TNPSC GRI Answer Prelims Exam Answer Key 2026" />
                <link rel="canonical" href="https://www.shankariasacademy.com/tnpsc-group-I-prelims-exam-answer-key/" />
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="website" />
                <meta property="og:title" content="TNPSC GRI Answer Exam Prelims Key 2026 | Shankar IAS Academy" />
                <meta property="og:description" content="TNPSC GRI Answer Exam Prelims Key 2026" />
                <meta property="og:url" content="https://www.shankariasacademy.com/tnpsc-group-I-prelims-exam-answer-key/" />
                <meta property="og:site_name" content="Shankar IAS Academy" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@shankarias" />
              </Head>        
              <Navbar title="IFS-Interview-2023" />

<div className="container">
    <div className="row">        
        <div className="col pt-3 pt-md-4">
            <h1 className={`${styles.pagemaintitle}`}>TNPSC GR I Prelims Exam Answer Key 2026</h1>
        </div>

        <div className={`${styles.bgbox} row`}>
            <div className="col-12 col-md-12 pt-3 pt-md-4">
                <div className="d-flex justify-content-center py-3 py-md-5">
                    <Link href="https://shankariasacademy.in-maa-1.linodeobjects.com/Group-I-Preliminary-Exam-2026-Answer-key.pdf" target="_blank" className={`${styles.btnbox}`}>
                    <p className="pt-3"> TNPSC GR I Prelims Exam Answer Key 2026</p>
                    <button className={`${styles.normalbutton} mb-3`}>Click Here</button>
                    </Link>
                </div>
                <p className="text-center">"Disclaimer: The Group I Preliminary 2026 answer keys may have a variation of 7% to 9%.
                </p>

                <p className="text-center"> <b>Note :</b> The Revised answer option for Question No. 101 is B  </p>
            </div>
  
            

           

            
        </div>
    </div>
</div>
        

        {/*<div className="container">

        <div className="row">
        <div className="col pt-3 pt-md-4">
            <h1 className={`${styles.pagemaintitle}`}>TNPSC Group IIA Mains Mock Test Result 2025</h1>
        </div>
       

        <div className={`${styles.bgbox} row`}>
           {/* <div className="col p-2">
                        <Image
                        src={WebBanner}
                        className="img-fluid w-100"
                        alt="IFS interview Banner"
                        title="UPSC IFS(Forestry) Interview Guidance Programme 2023"
                        />
            </div> 
             
            <div className="col col-md-6 pt-3 pt-md-4">
            <div className="d-flex justify-content-center py-3 py-md-5">
                <Link href="/pdf/tnpsc-mocktest-result-2025/Online/GT ONLINE RESULTS.pdf" target="_blank" className={`${styles.btnbox}`}> 
                <p className="pt-3">GR IIA Mains Mock Test Online GT Result</p>
                <button className={`${styles.normalbutton} mb-3`}>Click Here</button>
                </Link>
            </div>
            </div>

            <div className="col col-md-6 pt-3 pt-md-4">
            <div className="d-flex justify-content-center py-3 py-md-5">
                <Link href="/pdf/tnpsc-mocktest-result-2025/Online/GE ONLINE RESULTS.pdf" target="_blank" className={`${styles.btnbox}`}>
                <p className="pt-3"> GR IIA Mains Mock Test Online GE Result</p>
                <button className={`${styles.normalbutton} mb-3`}>Click Here</button>
                </Link>
            </div>
            </div>

            <div className="col col-md-6 pt-3 pt-md-4">
            <div className="d-flex justify-content-center py-3 py-md-5">
                <Link href="/pdf/tnpsc-mocktest-result-2025/Offline/GT FINAL RESULTS OFFLINE.pdf" target="_blank" className={`${styles.btnbox}`}>
                <p className="pt-3"> GR IIA Mains Mock Test Offline GT Result</p>
                <button className={`${styles.normalbutton} mb-3`}>Click Here</button>
                </Link>
            </div>
            </div>

            <div className="col col-md-6 pt-3 pt-md-4">
            <div className="d-flex justify-content-center py-3 py-md-5">
                <Link href="/pdf/tnpsc-mocktest-result-2025/Offline/GE FINAL RESULTS OFFLINE.pdf" target="_blank" className={`${styles.btnbox}`}>
                <p className="pt-3"> GR IIA Mains Mock Test Offline GE Result</p>
                <button className={`${styles.normalbutton} mb-3`}>Click Here</button>
                </Link>
            </div>
            </div>

           

            
        </div>
        </div>
        </div>*/}
       

        <Footer />
        </>
    )
}
export default ifsInterview2023